export default __webpack_public_path__ + "static/media/mx.05c8d697.svg";